import { NotificationManager } from "react-notifications";

import apiURL from "./apiURL";
import {Actions as GROUP_ACTIONS} from "./groupActions";

const Types = {
	SCHEME_SAVING: "SCHEME_SAVING",
	SCHEME_SAVE_CURRENT: "SCHEME_SAVE_CURRENT",
	SCHEME_OPEN_MODAL: "SCHEME_OPEN_MODAL",
	SCHEME_DELETE_MODAL: "SCHEME_DELETE_MODAL",
	SCHEME_DELETING: "SCHEME_DELETING",
	SCHEME_DELETED: "SCHEME_DELETED",
	SCHEME_CONFIRM_CHANGE_MODAL: "SCHEME_CONFIRM_CHANGE_MODAL",
	SCHEME_UPDATING: "SCHEME_UPDATING",
	SCHEME_UPDATE: "SCHEME_UPDATE",
};

const schemeSetSaving = (id) => ({
	type: Types.SCHEME_SAVING,
	id,
});

const schemeUpdateSaveStatus = (response, scheme) => ({
	type: Types.SCHEME_SAVE_CURRENT,
	payload: response,
	scheme,
});

const saveScheme = (scheme) => {
	return (dispatch, getState) => {
		dispatch(schemeSetSaving((scheme && scheme.id) || true));

		const path = "/settings/pension/scheme";

		fetch(apiURL + path, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(scheme),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(schemeUpdateSaveStatus(data, scheme));
				dispatch(getSchemes());
				NotificationManager.success("Scheme Saved Successfully", "Save Scheme");
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("An Error Occurred While Saving", "Save Scheme");
			});
	};
};

// const confirmModal = (status) => ({
//     type: Types.SCHEME_CONFIRM_CHANGE_MODAL,
//     status: status,
// });

const setOpenSchemeModal = (status, scheme) => {
	return (dispatch, getState) => {
		// if(!status) dispatch(confirmModal(true));
		dispatch({
			type: Types.SCHEME_OPEN_MODAL,
			status: status,
			scheme,
		});
	};
};

const deleteSchemeModal = (status, scheme) => ({
	type: Types.SCHEME_DELETE_MODAL,
	status: status,
	scheme,
});

const deletingScheme = () => ({
	type: Types.SCHEME_DELETING,
});

const deletedScheme = (response) => ({
	type: Types.SCHEME_DELETED,
	payload: response,
});

const deleteScheme = (scheme) => {
	return (dispatch, getState) => {
		dispatch(deletingScheme());

		fetch(apiURL + `/settings/pension/scheme/delete`, {
			credentials: "include",
			method: "DELETE",
			body: JSON.stringify({ id: scheme }),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then(() => {
				dispatch(deletedScheme());
				dispatch(getSchemes());
				NotificationManager.success("Scheme Deleted Successfully", "Delete Scheme");
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("An Error Has Occurred While Deleting", "Delete Scheme");
			});
	};
};

const schemeUpdating = (options) => ({
	type: Types.SCHEME_UPDATING,
	options,
});

const updateSchemes = (data) => ({
	type: Types.SCHEME_UPDATE,
	data,
});

const getSchemes = (options) => {
	const qs = new URLSearchParams(options).toString();
	return (dispatch, getState) => {
		dispatch(schemeUpdating(options));
		fetch(apiURL + `/settings/pension/scheme?${qs}`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(updateSchemes(data.schemes));
        dispatch(GROUP_ACTIONS.getGroups())
			});
	};
};

const Actions = {
	saveScheme,
	setOpenSchemeModal,
	deleteSchemeModal,
	deleteScheme,
	updateSchemes,
	// confirmModal,
	getSchemes,
};

export { Types, Actions };
